import i18next from 'i18next';

i18next.addResources('es', 'sectionsTable', {
    name: 'Nombre',
    description: 'Descripción',
    status: 'Etapa',
    investment: 'Inversión'
});
